import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import parseToTimestamp from "shared/utils/parseToTimestamp";

export const fetchInsuredPersonCase = createAsyncThunk(
    'contract/fetchInsuredPersonCase',
    async ({ PolicyID}: {
        PolicyID: string,
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "PolicyID": PolicyID
            };

            const response = await getRequest(requestBody, 'dms-hr', 'getInsuredPersonCase', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { policy: data.Policy, fetchTime: parseToTimestamp(new Date()) };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchPolicyDownload = createAsyncThunk(
    'contract/fetchPolicyDownload',
    async ({ PolicyID, DataType }: {
        PolicyID: string,
        DataType: string;
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "PolicyID": PolicyID,
                "DataType": DataType
            };

            const response = await getRequest(requestBody, 'dms-hr', 'downloadPolicy', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { FileData: data.File.DataBase64, FileName: data.File.Name };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);